export default __webpack_public_path__ + "static/media/iconn2.7a8a7474.svg";